import React, { Component } from 'react';
import Line from "../../main/Line";
import BackButton from '../../main/BackButton';

class FollowUs extends Component {
  render() {
    return (
      <>
        <BackButton />
        <Line
          type="bottom-line"
          onClick={() => window.open('https://www.instagram.com/wonwonleywon/', '_blank', 'noopener,noreferrer')}
          style={{ cursor: 'pointer' }}
        >
          Instagram
        </Line>
        <Line type="bottom-line">
          {/* <a href="https://twitter.com/wonwonleywon" target="_blank" style={{ color: "black", textDecoration: "none" }}>
            Twitter
          </a> */}
        </Line>
        <Line type="bottom-line">
          {/* <a href="https://www.tiktok.com/@wonwonleywon" target="_blank" style={{ color: "black", textDecoration: "none" }}>
            tiktok
          </a> */}
        </Line>
        <Line type="bottom-line" />
        <Line type="bottom-line" />
        <Line type="bottom-line" />
        <Line type="bottom-line" />
        <Line type="bottom-line" />
        <Line type="bottom-line" />
        <Line type="bottom-line" />
        <Line type="bottom-line" />
      </>
    );
  }
}

export default FollowUs;



